/**
 * Самозапись на ресурс (кресло, психолог, йога). Ключ со скоупом
 * `resource:booking` бронирует только ресурсы — переговорку им не создать,
 * поэтому его можно держать в бандле.
 */

import { request } from '../api'

const API_KEY = (import.meta.env.VITE_RESOURCE_API_KEY as string | undefined) || ''

export interface ResourceCard {
  id: number
  name: string
  description: string | null
  pricePerHour: number
  isAvailable: boolean
  location: { name: string; timezone: string } | null
}

export interface Slot {
  startTime: string
  endTime: string
  seatsTotal: number
  seatsFree: number
  available: boolean
}

export interface ResourceBookingResult {
  startTime: string
  endTime: string
}

export const getResource = (id: number) => request<ResourceCard>(`/resources/${id}`)

export const getSlots = (id: number, date: string) =>
  request<Slot[]>(`/resources/${id}/slots?date=${date}`)

export const bookResource = (payload: {
  roomId: number
  startTime: string
  endTime: string
  clientName: string
  clientPhone: string
}) =>
  request<ResourceBookingResult>(
    '/external/bookings',
    // Источник — в примечание брони, как делают витрины: админ видит, откуда она.
    { method: 'POST', body: JSON.stringify({ ...payload, description: 'Самозапись на ресурс' }) },
    { apiKey: API_KEY },
  )
